










































































import { mapActions, mapGetters } from 'vuex'
import { ModuleNames } from '@/store/module-names'
import { GetterNames as SiteGetterNames } from '@/store/modules/site/keys'
import { ActionNames as SiteActionNames } from '@/store/modules/site/keys'

export default {
  props: {
    showDialog: {
      type: Boolean,
      default: false,
    },
    site: {
      type: Object,
      required: true,
    },
    siteStats: {
      type: Object,
      required: true,
    },
  },
  data() {
    let explicitConfig = this.siteStats.siteUsageStats.explicitCashflowConfig
    return {
      saving: false,

      monthlyRevenue: explicitConfig.monthlyRevenue,
      monthlyCost: explicitConfig.monthlyCost,
      glucometerStripRevenue: explicitConfig.glucometerStripRevenue,
      // oneTimeGlucometerGatewayCost: this.siteStats.siteUsageStats.config.oneTimeGlucometerGatewayCost,
      // oneTimeVitalsGatewayCost: this.siteStats.siteUsageStats.config.oneTimeVitalsGatewayCost,
      // oneTimeVitalsGatewayRevenue: this.siteStats.siteUsageStats.config.oneTimeVitalsGatewayRevenue,

      gatewaySalePrice: explicitConfig.gatewaySalePrice,
      gatewayInstallationFee: explicitConfig.gatewayInstallationFee,

      saveDefaultForRegionalHealthAuthority: false,
    }
  },
  computed: {
    // ...mapGetters(ModuleNames.site, {
    //   sites: `${SiteGetterNames.sites}`,
    // }),
  },
  async mounted(): Promise<void> {
    //await Promise.all([this[SiteActionNames.getSites]()])
  },
  methods: {
    // ...mapActions(ModuleNames.site, [SiteActionNames.getSites]),
    ...mapActions(ModuleNames.site, [SiteActionNames.patchSite]),
    closeDialog() {
      this.$emit('closeDialog')
    },
    getValueOrNull(value) {
      if (value === null) return null
      if (('' + value).length == 0) {
        return null
      }
      return value
    },
    async saveSiteVariables() {
      this.site.monthlyRevenue = this.getValueOrNull(this.monthlyRevenue)
      this.site.monthlyCost = this.getValueOrNull(this.monthlyCost)
      this.site.glucometerStripRevenue = this.getValueOrNull(this.glucometerStripRevenue)
      // this.site.oneTimeGlucometerGatewayCost = this.getValueOrNull(this.oneTimeGlucometerGatewayCost)
      // this.site.oneTimeVitalsGatewayCost = this.getValueOrNull(this.oneTimeVitalsGatewayCost)
      // this.site.oneTimeVitalsGatewayRevenue = this.getValueOrNull(this.oneTimeVitalsGatewayRevenue)
      this.site.gatewaySalePrice = this.getValueOrNull(this.gatewaySalePrice)
      this.site.gatewayInstallationFee = this.getValueOrNull(this.gatewayInstallationFee)
      this.site.saveDefaultForRegionalHealthAuthority = this.getValueOrNull(this.saveDefaultForRegionalHealthAuthority)
      this.saving = true
      await this.patchSiteDetails(this.site)
      this.saving = false
      this.afterSaveSiteVariables()
    },
    async patchSiteDetails(site) {
      let s = site
      await this[SiteActionNames.patchSite]({
        id: site.id,
        attributes: site,
      })
    },
    afterSaveSiteVariables() {
      this.$emit('afterSaveSiteVariables')
    },
  },
}
